import type { CampaignStatus } from './CampaignTag.types';

export function getMonthName(date: Date) {
  return date.toLocaleString('en-US', { month: 'short' });
}

export function calculateCampaignStatus(startDate: string, endDate: string): CampaignStatus {
  const start = new Date(startDate || '').getTime();
  const end = new Date(endDate || '').getTime();
  const now = new Date().getTime();

  if (now < start) {
    return 'upcoming';
  }

  if (now >= start && now < end) {
    return 'ongoing';
  }
  if (now > end) {
    return 'ended';
  }
  return 'unknown';
}
